export const CURRENCIES = {
  USD: { code: "USD", symbol: "$", label: "USD ($)" },
  EUR: { code: "EUR", symbol: "€", label: "EUR (€)" },
  GBP: { code: "GBP", symbol: "£", label: "GBP (£)" },
  CAD: { code: "CAD", symbol: "C$", label: "CAD (C$)" },
  AUD: { code: "AUD", symbol: "A$", label: "AUD (A$)" },
  JPY: { code: "JPY", symbol: "¥", label: "JPY (¥)" },
  INR: { code: "INR", symbol: "₹", label: "INR (₹)" },
};

export const formatMoney = (amount, currency = "USD") => {
  const c = CURRENCIES[currency] || CURRENCIES.USD;
  const n = Number(amount || 0);
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  const digits = c.code === "JPY" ? 0 : 2;
  return `${sign}${c.symbol}${abs.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
};

export const CATEGORIES = ["Housing", "Utilities", "Subscriptions", "Food", "Transport", "Debt", "Health", "Other"];
export const INCOME_CATEGORIES = ["Starting Net", "Salary", "Freelance", "Bonus", "Side Hustle", "Investment", "Other"];
export const FREQUENCIES = [
  { value: "one-time", label: "One-time" },
  { value: "weekly", label: "Weekly" },
  { value: "biweekly", label: "Bi-weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "yearly", label: "Yearly" },
];

// Given a bill/income with first_date and frequency, return all occurrence date strings within [start, end]
export const occurrencesInRange = (firstDateStr, frequency, startDate, endDate) => {
  const first = new Date(firstDateStr + "T00:00:00");
  const start = new Date(startDate);
  const end = new Date(endDate);
  const out = [];
  const iso = (d) => d.toISOString().slice(0, 10);

  if (frequency === "one-time") {
    if (first >= start && first <= end) out.push(iso(first));
    return out;
  }
  let cur = new Date(first);
  // Fast-forward to be near start
  if (frequency === "weekly") {
    while (cur < start) cur.setDate(cur.getDate() + 7);
    while (cur <= end) { out.push(iso(cur)); cur.setDate(cur.getDate() + 7); }
  } else if (frequency === "biweekly") {
    while (cur < start) cur.setDate(cur.getDate() + 14);
    while (cur <= end) { out.push(iso(cur)); cur.setDate(cur.getDate() + 14); }
  } else if (frequency === "monthly") {
    while (cur < start) cur.setMonth(cur.getMonth() + 1);
    while (cur <= end) { out.push(iso(cur)); cur.setMonth(cur.getMonth() + 1); }
  } else if (frequency === "yearly") {
    while (cur < start) cur.setFullYear(cur.getFullYear() + 1);
    while (cur <= end) { out.push(iso(cur)); cur.setFullYear(cur.getFullYear() + 1); }
  }
  return out;
};

export const monthRange = (year, month /* 0-based */) => {
  const start = new Date(year, month, 1);
  const end = new Date(year, month + 1, 0);
  return { start, end, startIso: start.toISOString().slice(0, 10), endIso: end.toISOString().slice(0, 10) };
};

export const isoDate = (d) => new Date(d).toISOString().slice(0, 10);
export const todayIso = () => new Date().toISOString().slice(0, 10);
